export enum ModalStatusMassEditEnum {
	INACTIVE = 'inactive',
	PROPERTY_SELECTION = 'propertySelection',
	PROPERTY_MODIFICATION = 'propertyModification'
}
